export default __webpack_public_path__ + "static/media/discord.660fe2e8.png";